import React from 'react';
import { Link } from 'react-router-dom';
import { useParams } from '../../../../services/routing/useRouteInfo';
import { ViewLayout } from '../../../shared/cardLayouts/viewLayout';
import { AcceptingNewPatientsCard } from '../../../shared/cards/acceptingNewPatientsCard';
import { ScheduleCard } from '../../../shared/cards/scheduleCard';
import { NoteCard } from '../../../shared/cards/noteCard';
import { StatCard } from '../../../shared/cards/statCard';
import { LoadText } from '../../../shared/load/loadText';
import { View } from '../../../shared/view/view';
import { pathJoin } from '../../../../services/api';
import { AddSchedule, Delete, Edit } from '../../../shared/actions/actionButtons';
import { useHasPermission } from '../../../../services/auth/auth';
import { BRANCH, ZIPCODE } from '../../../../permissions';

import styles from './zipcodeView.module.css';

export const ZipcodeView = () => {

    let { id } = useParams();

    const canWriteBranches = useHasPermission(BRANCH.WRITE);

    const branches = data => <>{
        (data.schedules ?? []).map((s, i) => (<span key={s.branch.id}>
            { (i !== 0) ? ', ' : '' }
            <Link to={'locations/branches/' + s.branch.id}>{s.branch.name}</Link>
        </span>))
    }</>

    return <View
        id={parseInt(id ?? '')}
        resourceName='Zip Code'
        nameFunction={r => r?.zip + ', ' + r?.city}
        restEndpoint='locations/zipcodes'
        listUrl='locations/zipcodes'
        readPermissions={[ZIPCODE.READ]}
        writePermissions={[ZIPCODE.WRITE]}
        actions={[Edit, Delete, AddSchedule]}
    >
        {
            ({ loading, data, canWrite, canRead, refreshData }) => <ViewLayout>
                {data.note ? <NoteCard
                    columns={3}
                    restEndpoint={pathJoin('locations', 'zipcodes', id)}
                    refreshData={refreshData}
                    title='Zip Code Note'
                    editButton={canWrite}
                    deleteButton={canWrite}
                >{data.note}</NoteCard> : ''}
                <StatCard
                    title='Zip Code Info'
                    stats={{
                        'Zip Code': loading ? <LoadText /> : data.zip,
                        'Name': loading ? <LoadText /> : data.city,
                        'Branches': loading ? <LoadText /> : branches(data),
                    }}
                />
                <AcceptingNewPatientsCard loading={loading} accepting={data.acceptingNewPatients} />
                {
                    loading ? <>
                        <ScheduleCard
                            title={<>
                                <LoadText max={50} />'s Schedule
                            </>}
                            loading={true}
                            editButton={false}
                            deleteButton={false}
                        />
                    </>
                    :
                    (data.schedules ?? []).map((s, i) => (
                        <ScheduleCard
                            key={s.id}
                            schedule={s}
                            title={<>
                                <Link to={'/locations/branches/' + s.branch.id}>{s.branch.name}'s</Link> Schedule
                            </>}
                            branchId={s.branch.id}
                            editButton={canWrite && canWriteBranches}
                            deleteButton={canWrite && canWriteBranches}
                            refreshData={d => refreshData()}
                        />
                    ))
                }
            </ViewLayout>
        }
    </View>
}